import React from "react";
import Accordion from "react-bootstrap/Accordion";
import { Link } from "react-router-dom";
const Faq = () => {
  return (
    <div className="teams" id="faq">
      <div className="faqs">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="heading">
                <h6>FAQs</h6>
                <h4>Frequently Asked Questions</h4>
                <p>
                  If you can't find your question here, please feel free to
                  &nbsp; <Link to="">contact us.</Link>
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 pt-5 pt-lg-0">
              <Accordion className="faq-accordion row">
                <div className="col-lg-5 col-sm-12">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      Is my data secure on this platform?
                    </Accordion.Header>
                    <Accordion.Body>
                      Your data will be secure, if you use a secure crypto
                      wallet and take precautions to avoid phishing.
                    </Accordion.Body>
                  </Accordion.Item>
                </div>
                <div className="offset-lg-1 col-lg-5 col-sm-12">
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>
                      How can I make a purchase?
                    </Accordion.Header>
                    <Accordion.Body>
                      Just Click on ANY of the buttons labeled: "Connect
                      Wallet", "Buy with USDT or USDC," "Buy with Credit/Debit
                      Cards" or "Buy with PayPal". If any of the buttons are not
                      working, it means that it's a work in progress, so choose
                      an alternative button/method.
                    </Accordion.Body>
                  </Accordion.Item>
                </div>
                <div className="col-lg-5 col-sm-12">
                  <Accordion.Item eventKey="2">
                    <Accordion.Header>
                      What payment methods are accepted!
                    </Accordion.Header>
                    <Accordion.Body>
                      You can buy Zeuss Tokens with USDT or USDC Stable coins,
                      use your Credit/Debit Cards or use PayPal.
                    </Accordion.Body>
                  </Accordion.Item>
                </div>
                {/* <div className="offset-lg-1 col-lg-5 col-sm-12">
                  <Accordion.Item eventKey="3">
                    <Accordion.Header>
                      What rewards can I earn from Staking?
                    </Accordion.Header>
                    <Accordion.Body>
                      As we're focusing on building a unicorn, we're currently
                      offering life-changing opportunities by offering Staking
                      for only 1 Year or 6 Month Staking Periods, to incentivise
                      HODLING.
                      <br />1 Year Staking = 1,000% APY
                      <br />6 Months Staking = 500% APY
                      <br />
                      The Staking rewards, will reduce in a straight line at 10%
                      every 10 days for BOTH Staking Periods until they freeze
                      at 250% APY for I Year Staking and 125% APY for 6 Months
                      Staking.
                      <br />
                      The administration of Zeuss Token, reserves the right to
                      terminate the Staking Program at any time at it's absolute
                      discretion and all accruals will be claimable on a
                      pro-rata basis.
                      <br />
                      Early withdrawal will only result in full forfeiture of
                      all accrued Staking rewards, plus attract an Admin Fee of
                      5% on the total amount Staked.
                      <br />
                      However, early withdrawal at any time after voluntary
                      extension of Staking (Extended Staking period by
                      Restaking) will only result in full forfeiture of the
                      accrued Staking rewards plus attract an Admin Fee of 5%
                      for the Extended Staking Period by Restaking.
                    </Accordion.Body>
                  </Accordion.Item>
                </div> */}
                {/* <div className="col-lg-5 col-sm-12">
                  <Accordion.Item eventKey="4">
                    <Accordion.Header>
                      What is token staking and how does it work?
                    </Accordion.Header>
                    <Accordion.Body>
                      Token staking is a process where you lock up your
                      cryptocurrency (in this case, ZEUSS tokens) in a smart
                      contract to support the network and earn rewards.
                      <br />
                      Just CLICK on the Staking button, Connect your wallet and
                      follow instructions.
                    </Accordion.Body>
                  </Accordion.Item>
                </div> */}
                <div className="offset-lg-1 col-lg-5 col-sm-12">
                  <Accordion.Item eventKey="5">
                    <Accordion.Header>
                      Can I use PayPal to make a purchase during the Pre-Sale?
                    </Accordion.Header>
                    <Accordion.Body>Yes</Accordion.Body>
                  </Accordion.Item>
                </div>
                {/* <div className="col-lg-5 col-sm-12">
                  <Accordion.Item eventKey="6">
                    <Accordion.Header>
                      Is there a minimum number of tokens required for Staking?
                    </Accordion.Header>
                    <Accordion.Body>5,000 Zeuss Tokens</Accordion.Body>
                  </Accordion.Item>
                </div> */}
                <div className="col-lg-5 col-sm-12">
                  <Accordion.Item eventKey="7">
                    <Accordion.Header>
                      How do I contact support?
                    </Accordion.Header>
                    <Accordion.Body>
                      CLICK on &nbsp;
                      <Link to="mailto:support@zeuss.one">
                        support@zeuss.one
                      </Link>
                    </Accordion.Body>
                  </Accordion.Item>
                </div>
              </Accordion>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faq;
